import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "home"
}
const _hoisted_2 = { class: "main-body d-flex flex-row" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "container p-0" }

import { ref, computed, getCurrentInstance, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import SaleTimeOut from "@/shared-components/common/SaleTimeout.vue";
import NavigationBar from "@/shared-components/common/NavigationBar.vue";
import Policy from "@/apps/merchant3/components/steps/policy/Policy.vue";
import HelpMessage from "@/apps/merchant3/components/HelpMessage.vue";
import Spinner from "@/shared-components/ui/Spinner.vue";
import InConsoleSidebar from "@/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue";

import {
  productVersionRecordingAppsMapper,
  recorder,
} from "@/shared-services/recording.service";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";
import { CheckoutStep } from "@/apps/merchant3/enums/checkoutStepEnum";
import useConfigurations from "@/apps/merchant3/hooks/useConfigurations";
import { usePageTitle } from "../../hooks/usePageTitle";


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyView',
  setup(__props) {

const route = useRoute();
const store = useStore();
const { t } = useI18n();
const { globalComponents, isConfigLoaded, loadConfigs } = useConfigurations();
const showSuspiciousSaleFlag = computed(() => {
  return globalComponents.value?.showSuspiciousSaleFlag ?? false;
});
const showInconsoleSidebar = computed(
  () =>
    globalComponents.value?.showInConsoleMessages ||
    globalComponents.value?.showInConsoleTraining ||
    false
);
const showChatBot = computed(
  () => globalComponents.value?.showChatBot ?? false
);

const currentStep = route.meta.step as CheckoutStep;
const LinkToHome = ref(RouteName.M3Welcome);
const app = getCurrentInstance()?.appContext.app;
usePageTitle("PayJoy - " + t("PAGE_TITLE_PRIVACY_POLICY"));

const loading = ref(true);

const cartTag = computed(() => store.state.carts.cartTag);

const updateRecorder = () => {
  recorder(app)?.updateRecordingInfo(store.state.carts.userId, {
    cartTag: store.state.carts.cartTag,
    merchantId: store.state.carts.merchantId,
    clerkId: store.state.carts.salesClerkId,
    productVersion: store.state.carts.productVersion,
    country: store.state.merchant?.merchant?.country,
  });
};

watch(
  [cartTag, isConfigLoaded],
  () => {
    if (cartTag.value && isConfigLoaded.value) {
      loading.value = false;
    }
  },
  { immediate: true }
);

onMounted(async () => {
  useCartPersistState(() => {
    loadConfigs(cartTag.value, currentStep);
    store.dispatch("carts/setStep", RoutesPageSteps.TermsAndConditions);
    const recordingApp = productVersionRecordingAppsMapper(
      store.state.carts.productVersion
    );
    recorder(app)?.startRecording(recordingApp);
    updateRecorder();
    return true;
  });
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(HeaderM3, {
          logoLinkRoute: LinkToHome.value,
          showSuspiciousActivityButton: _unref(showSuspiciousSaleFlag),
          showChat: _unref(showChatBot)
        }, null, 8, ["logoLinkRoute", "showSuspiciousActivityButton", "showChat"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(NavigationBar),
            _createVNode(SaleTimeOut),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Policy)
            ])
          ]),
          (_unref(showInconsoleSidebar))
            ? (_openBlock(), _createBlock(InConsoleSidebar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(HelpMessage)
      ]))
}
}

})